import { useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Cursor } from "@/components/Cursor";
import { Navbar } from "@/components/Navbar";
import { JoinModal } from "@/components/JoinModal";
import { CartDrawer } from "@/components/CartDrawer";
import { FeedbackWidget } from "@/components/FeedbackWidget";
import { CartProvider } from "@/lib/cart";
import { useScrollBehavior } from "@/lib/useScrollBehavior";
import Landing from "@/pages/Landing";
import FlavorPage from "@/pages/FlavorPage";
import RecipesPage from "@/pages/RecipesPage";
import AdminPage from "@/pages/AdminPage";
import JournalPage from "@/pages/JournalPage";
import JournalPostPage from "@/pages/JournalPostPage";
import QuizPage from "@/pages/QuizPage";
import ManifestoPage from "@/pages/ManifestoPage";
import GremlinsPage from "@/pages/GremlinsPage";
import MerchPage from "@/pages/MerchPage";
import LinksPage from "@/pages/LinksPage";
import ThanksPage from "@/pages/ThanksPage";

function Shell() {
  const [clubOpen, setClubOpen] = useState(false);
  const location = useLocation();
  const scrollTo = useScrollBehavior();

  const openClub = useCallback(() => setClubOpen(true), []);
  const hideNav = location.pathname === "/links";

  return (
    <div className="App bg-void relative">
      <Cursor />
      <div className="grain-overlay" />
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#161514", border: "1px solid rgba(224,140,45,0.4)", color: "#F6F1E5", fontFamily: "IBM Plex Mono, monospace" } }} />

      {!hideNav && <Navbar onJoin={openClub} onNav={scrollTo} />}
      <Routes>
        <Route path="/" element={<Landing onJoin={openClub} onNav={scrollTo} />} />
        <Route path="/flavor/:id" element={<FlavorPage onJoin={openClub} />} />
        <Route path="/recipes" element={<RecipesPage />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
        <Route path="/gremlins" element={<GremlinsPage />} />
        <Route path="/merch" element={<MerchPage onJoin={openClub} />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/journal/:slug" element={<JournalPostPage />} />
        <Route path="/quiz" element={<QuizPage onJoin={openClub} />} />
        <Route path="/links" element={<LinksPage onJoin={openClub} />} />
        <Route path="/thanks" element={<ThanksPage onJoin={openClub} />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>

      <CartDrawer onJoin={openClub} />
      {!hideNav && <FeedbackWidget />}
      <JoinModal open={clubOpen} onClose={() => setClubOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Shell />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
